import { render, staticRenderFns } from "./EditFieldItems.vue?vue&type=template&id=b3c6546e"
import script from "./EditFieldItems.vue?vue&type=script&lang=js"
export * from "./EditFieldItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports